import { Nav } from "../../molecules/Nav/Nav.client"
import { AESTTime } from "../../atoms/AESTTime/AESTTime.client"
// import { AnimatedGrid } from "../../molecules/AnimatedGrid/AnimatedGrid.client"

export const Layout = () => {
  Nav()
  AESTTime()
  // AnimatedGrid()
}
